import { Auth } from 'aws-amplify';

import { axios } from './axios';

export const fetchRegister = async ({
  firstName,
  lastName,
  email,
  password,
}) => {
  const response = await Auth.signUp({
    username: email,
    password,
    attributes: {
      email,
      name: firstName,
      family_name: lastName,
    },
  });

  return response.userSub;
};

export const fetchRegisterCodeResend = async ({ email }) => {
  await Auth.resendSignUp(email);
};

export const fetchLogin = async ({ email, password }) => {
  return Auth.signIn(email, password);
};

export const fetchCompleteNewPassword = async ({
  cognitoUser,
  newPassword,
}) => {
  return Auth.completeNewPassword(cognitoUser, newPassword);
};

export const fetchForgotPassword = async ({ email }) => {
  const response = await axios.post('forgot-password', { email });

  const { type } = JSON.parse(response.data.body);

  return type;
};

export const fetchForgotPasswordSubmit = async ({
  username,
  password,
  code,
}) => {
  await Auth.forgotPasswordSubmit(username, `${code}`, password);
};

export const fetchCurrentCognitoUser = async () => {
  return Auth.currentAuthenticatedUser();
};

export const fetchLogout = async () => {
  await Auth.signOut();
};

export const fetchUpdateUser = async ({ attributes }) => {
  const user = await fetchCurrentCognitoUser();

  await Auth.updateUserAttributes(user, attributes);
};

export const fetchChangePassword = async ({ oldPassword, newPassword }) => {
  const cognitoUser = await fetchCurrentCognitoUser();

  await Auth.changePassword(cognitoUser, oldPassword, newPassword);
};
